import { COLORS, COLORLESS } from "@/lib/mtg";

export function ColorPips({ colors = [] }) {
  const list = colors.length ? COLORS.filter((c) => colors.includes(c.key)) : [COLORLESS];
  return (
    <span className="inline-flex gap-1" aria-label={`Colors: ${list.map((c) => c.name).join(", ")}`}>
      {list.map((c) => (
        <span key={c.key} title={c.name} className={`h-3 w-3 rounded-full border ${c.cls}`} />
      ))}
    </span>
  );
}

export function ColorToggles({ value, onChange, includeColorless = false, size = "md", testidPrefix = "color-toggle" }) {
  const options = includeColorless ? [...COLORS, COLORLESS] : COLORS;
  const dim = size === "sm" ? "h-6 w-6 text-[10px]" : "h-8 w-8 text-xs";
  const toggle = (key) => onChange(value.includes(key) ? value.filter((k) => k !== key) : [...value, key]);
  return (
    <div className="flex gap-1" role="group" aria-label="Colors">
      {options.map((c) => {
        const active = value.includes(c.key);
        return (
          <button
            type="button"
            key={c.key}
            aria-pressed={active}
            aria-label={c.name}
            title={c.name}
            data-testid={`${testidPrefix}-${c.key}`}
            onClick={() => toggle(c.key)}
            className={`${dim} rounded-full border font-mono font-bold transition-[opacity,transform,box-shadow] duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 ${c.cls} ${
              active ? "opacity-100 scale-105 shadow-[0_0_12px_rgba(251,191,36,0.45)]" : "opacity-35 hover:opacity-70"
            }`}
          >
            {c.key}
          </button>
        );
      })}
    </div>
  );
}
